// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeOutlinedSvg from "@fishx/icons-svg/es/asn/HomeOutlined";
import FishxIcon from '../components/FishxIcon';

var HomeOutlined = function HomeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeOutlinedSvg
  }));
};

HomeOutlined.displayName = 'HomeOutlined';
export default React.forwardRef(HomeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HomeOutlined.js
// module id = 2938
// module chunks = 0